import React from 'react'
import './Announcement.css'

// const Announcement = () => {
//   return (
//     <div>
//       <div className='main'>
//          <div className='left'>English | Be a Seller</div>
     
//          <div className='right'>Track order  |  Help Line +01 112 352 566  |  Wishlist (0)</div>
//       </div>
//     </div>
//   )
// }

// export default Announcement



const Announcement = () => {
  return (
    <div className='bor h-50 mt-2'>
      <span className="font-monospace m"> English | Be a Seller</span>
      <span className="font-monospace margin"> Track order  |  Help Line +01 112 352</span>
      
    </div>
  )
}

export default Announcement